import { render, staticRenderFns } from "./ProfitReportDetail.vue?vue&type=template&id=64c1c61f"
import script from "./ProfitReportDetail.vue?vue&type=script&lang=js"
export * from "./ProfitReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports